<template>
  <section id="header">
    <HeaderBanners
      :event="event"
      :user="user"
      :showBanners="show_banners"
      :isPlayerPage="isPlayerPage"
      :banner_docsok_msg="banner_docsok_msg"
    />
    <div id="top-nav">
      <div class="left">
        <span v-if="title_one" class="title_one active">
          {{ $t('titles.' + title_one) }}
        </span>
      </div>

      <div class="right" v-if="action_one || action_two">
        <div
          class="collapseable"
          @click="collapsedActions = !collapsedActions"
        ></div>

        <div class="actions" :class="{ closed: collapsedActions, opened: !collapsedActions }">
          <button
            v-if="action_one"
            class="action"
            :id="page === 'payments' ? 'cancel' : 'add'"
            @click="handleAction('one')"
          >
            {{ $t(action_one) }}
          </button>

          <button
            v-if="action_two"
            class="action"
            id="cancel"
            @click="handleAction('two')"
          >
            {{ $t(action_two) }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { resolveBreadcrumb } from '@/helpers/breadcrumb-navigation'
import HeaderBanners from '@/components/layout/header/HeaderBanner.vue'
import { resolvePrimaryAction, resolveSecondaryAction } from '@/helpers/header-actions'
export default {
  components: { HeaderBanners },
  props: [
    'page',
    'title_one',
    'title_two',
    'title_three',
    'action_one',
    'action_two',
    'person_id',
    'show_banners',
    'banner_docsok_msg'
  ],
  data () {
    return {
      collapsedActions: true
    }
  },
  methods: {
    handleAction (which) {
      if (which === 'one') {
        this.button_one()
      } else {
        this.button_two()
      }
      this.collapsedActions = true
    },
    button_one () {
      const route = resolvePrimaryAction(this.page, this)
      if (route) {
        this.$router.push(route).catch(() => {})
      }
    },
    button_two () {
      const route = resolveSecondaryAction(this.page, this)
      if (route) {
        this.$router.push(route).catch(() => {})
      }
    },
    navigateBreadcrumb (level) {
      const route = resolveBreadcrumb(level, this.page, this.team)
      if (route) {
        this.$router.push(route).catch(() => {})
      }
    }
  },
  created () {},
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },
    team () {
      return this.$store.getters['team/getTeam']
    },

    club () {
      return this.$store.getters['club/getClub']
    },

    event () {
      var event = this.$store.getters.getCurrentEvent()
      if (!event) {
        event = {}
      }
      return event
    },

    isPlayerPage () {
      return ['player', 'players_add', 'player_edit'].includes(
        this.$route.name
      )
    }
  }
}
</script>

<style lang="scss" scoped>
#top-nav {
  height: $header-height;
  overflow: hidden;
  width: 100%;
  right: 0;
  top: 80px;
  padding: 10px 0px;
  z-index: $z-header;
  background-color: #fff;
  margin-left: 0;
  z-index: 22;
}

.left,
.right {
  @include display-flex();
  @include align-items();
  padding: 0 5px;
}

.left {
  height: 100%;
  position: relative;
  float: left;
  width: 50%;

  span {
    font-size: 18px;
  }

  .separator {
    margin: 0 4px;
  }

  .title_one,
  .title_two,
  .title_three {
    @include text-ellipsis();
    font-family: AvantGarde-Bold;
    font-size: 28px;
    line-height: 40px;
    color: #222;

    &:hover {
      text-decoration: underline;
    }
  }

  .active {
    color: #222;
    font-weight: bold;

    &:hover {
      text-decoration: none;
    }
  }
}

.right {
  @include justify-content(flex-end);
  height: 100%;
  position: relative;
  float: right;
  width: 50%;

  .action {
    float: right;
    min-width: 40px;
    padding: 0 35px;
    font-size: 16px;
    border-radius: 3px;
    height: 40px;
    margin-left: 6px;
    line-height: 40px;
    font-family: AvantGarde-Bold;
    cursor: pointer;
    border: 1px solid #fc8926;
    transition: all 0.5s;
    text-transform: uppercase;

    &#add {
      background-color: #fc8926;
      color: #fff;

      &:hover {
        background-color: #e78026;
        border-color: #e78026;
      }
    }

    &#cancel {
      background-color: transparent;
      color: #c55c00;

      &:hover {
        background-color: #fc8a2623 !important;
      }
    }
  }
}

.collapseable {
  display: none;
}

// Responsive styles
@include media(">767px", "<1024px") {
  #top-nav {
    padding-left: 0px;
  }
}

@include media(">phone", "<desktop") {
  #top-nav {
    width: 100%;
    padding-left: 20px;
  }

  #left-menu.opened ~ #main-content #top-nav {
    padding-left: 0;
    padding-right: 50px;
  }

  .left,
  .right {
    z-index: 9999;
  }

  .left {
    width: 100%;
    padding: 0 6px;

    .title_one,
    .title_two,
    .title_three {
      max-width: 60px;
      font-size: 22px;
    }

    .active {
      max-width: unset;
    }
  }

  .right {
    @include border-radius(100%);
    position: fixed;
    bottom: 5px;
    right: 15px;
    padding: 0;
    width: 50px;
    height: 50px;
    background-color: #fc8926;

    .collapseable {
      @include background($image: img("menu.svg"), $size: 20px);
      display: block;
      width: 50px;
      height: 50px;
    }

    .actions {
      position: fixed;
      bottom: 60px;
      right: 15px;
      z-index: 999;

      &.closed {
        display: none;
      }

      &.opened {
        @include display-flex();
        @include flex-wrap();
        @include flex-direction(column);
      }

      .action {
        @include border-radius(24px);
        background-color: #fc8926;
        width: auto;
        margin: 6px 0 0 0;
        display: block;

        &#cancel {
          background-color: white;
        }
      }
    }
  }
}
</style>
